const dispatch = require("~/store.js").dispatch;
const server = require("~/server.js");
const OpenSurveySummary = require("~/navigator.js").OpenSurveySummary;

const events = require("./auditCompletionEvents.js");

const auditCompletionDispatchers = {
    Submit(auditTypeName, facNumber, surveyID) {
        const path = `audit/${auditTypeName}/${facNumber}/${surveyID}/complete`;

        dispatch((thunkDispatch) => {
            const started = events.Started.New();

            thunkDispatch(started);
            
            server.Put(path)
                .then(() => {
                    const completed = events.Completed.New(
                        auditTypeName,
                        facNumber,
                        surveyID);

                    thunkDispatch(completed);

                    OpenSurveySummary(auditTypeName, facNumber, surveyID);
                })
                .catch((ex) => {
                    const errored = events.Errored.New(ex);

                    thunkDispatch(errored);
                });
        });
    },
    ScoreSample(audityTypeName, facNumber, surveyID) { 
        const path = `audit/${audityTypeName}/${facNumber}/${surveyID}/scoresample`;

        dispatch((thunkDispatch) => {
            server.Get(path)
                .then((response) => {
                    return response.json(); 
                })
                .then((samplescore) => {
                    const sampleScore = events.SampleScore.New(samplescore.Score, samplescore.MaxScore);

                    thunkDispatch(sampleScore); 
                })
                .catch((ex) => {
                    const erroed = events.SampleScoreErrored.New(ex);

                    thunkDispatch(errored); 
                })
        }); 
    }, 
    ClearError() {
        const clear = events.ErrorCleared.New();

        dispatch(clear);
    }
};

module.exports = auditCompletionDispatchers;


// WEBPACK FOOTER //
// ./src/events/auditCompletion/auditCompletionDispatchers.js